import { Component } from '@angular/core';

@Component({
  selector: 'app-inspire-hero',
  templateUrl: './inspire-hero.component.html',
  styleUrls: ['./inspire-hero.component.scss']
})
export class InspireHeroComponent {

}
